var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-flex",
    { attrs: { xs12: "", sm12: "", "pa-4": "", layout: "", wrap: "" } },
    [
      _c(
        "v-flex",
        { attrs: { xs12: "", sm6: "", md3: "" } },
        [
          _c("v-text-field", {
            attrs: {
              label: "Serie Número",
              clearable: "",
              "prepend-icon": "abc"
            },
            on: { change: _vm.handleFilters },
            model: {
              value: _vm.paramApi.serienumero,
              callback: function($$v) {
                _vm.$set(_vm.paramApi, "serienumero", $$v)
              },
              expression: "paramApi.serienumero"
            }
          })
        ],
        1
      ),
      _c(
        "v-flex",
        { attrs: { xs12: "", sm6: "", md3: "" } },
        [
          _c("DatePicker", {
            attrs: { label: "Fecha Baja Inicio", max: _vm.now },
            model: {
              value: _vm.paramApi.start_date,
              callback: function($$v) {
                _vm.$set(_vm.paramApi, "start_date", $$v)
              },
              expression: "paramApi.start_date"
            }
          })
        ],
        1
      ),
      _c(
        "v-flex",
        { attrs: { xs12: "", sm6: "", md3: "" } },
        [
          _c("DatePicker", {
            attrs: { label: "Fecha Baja Fin", max: _vm.now },
            model: {
              value: _vm.paramApi.end_date,
              callback: function($$v) {
                _vm.$set(_vm.paramApi, "end_date", $$v)
              },
              expression: "paramApi.end_date"
            }
          })
        ],
        1
      ),
      _c(
        "v-flex",
        { attrs: { xs12: "", sm6: "", md3: "" } },
        [
          _c("v-text-field", {
            attrs: {
              label: "Nombre Baja",
              clearable: "",
              "prepend-icon": "abc"
            },
            on: { change: _vm.handleFilters },
            model: {
              value: _vm.paramApi.nombre_baja,
              callback: function($$v) {
                _vm.$set(_vm.paramApi, "nombre_baja", $$v)
              },
              expression: "paramApi.nombre_baja"
            }
          })
        ],
        1
      ),
      _c(
        "v-flex",
        { attrs: { xs12: "", sm6: "", md3: "" } },
        [
          _c("v-autocomplete", {
            attrs: {
              label: "Ubicación",
              items: _vm.filterApi.UBICACIONES,
              "item-text": "tipoubicaname",
              "item-value": "tipoubicaid",
              clearable: "",
              "return-object": "",
              "prepend-icon": "pin_drop"
            },
            on: { change: _vm.handleFilters },
            model: {
              value: _vm.paramApi.ubicacion,
              callback: function($$v) {
                _vm.$set(_vm.paramApi, "ubicacion", $$v)
              },
              expression: "paramApi.ubicacion"
            }
          })
        ],
        1
      ),
      _c(
        "v-flex",
        { attrs: { xs12: "", sm6: "", md3: "" } },
        [
          _c("v-autocomplete", {
            attrs: {
              label: "Cliente",
              items: _vm.filterApi.CLIENTES,
              "item-text": "cliente",
              "item-value": "rut",
              clearable: "",
              "return-object": "",
              "prepend-icon": "apartment"
            },
            on: { change: _vm.handleFilters },
            model: {
              value: _vm.paramApi.cliente,
              callback: function($$v) {
                _vm.$set(_vm.paramApi, "cliente", $$v)
              },
              expression: "paramApi.cliente"
            }
          })
        ],
        1
      ),
      _c(
        "v-flex",
        {
          attrs: {
            xs12: "",
            sm6: "",
            md3: "",
            layout: "",
            "justify-center": "",
            wrap: "",
            "mt-2": ""
          }
        },
        [
          _c(
            "v-btn",
            { on: { click: _vm.handleSearchFilter } },
            [
              _c("v-icon", { attrs: { color: "#27488e" } }, [_vm._v("search")]),
              _vm._v("Filtrar\n    ")
            ],
            1
          ),
          _c(
            "v-btn",
            {
              on: {
                click: function($event) {
                  return _vm.handleCleanFilters()
                }
              }
            },
            [
              _c("v-icon", { attrs: { color: "#27488e" } }, [_vm._v("clear")]),
              _vm._v("Limpiar\n    ")
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }